module.exports = __webpack_public_path__ + "static/media/QB_W250px.831136b7.png";